module.exports = __webpack_public_path__ + "img/PRINT.29163378.svg";